import { Badge, Segmented } from "antd";

import styles from "../ProjectTeamPage.module.css";

export type TeamFilter = "all" | "new";

interface TeamFilterTabsProps {
  activeFilter: TeamFilter;
  onChange: (filter: TeamFilter) => void;
  allUsersLabel: string;
  newUsersLabel: string;
  newMembersCount: number;
}

const TeamFilterTabs = ({
  activeFilter,
  onChange,
  allUsersLabel,
  newUsersLabel,
  newMembersCount
}: TeamFilterTabsProps) => (
  <div className="my-5">
    <Segmented<TeamFilter>
      className={styles.filterSegmented}
      value={activeFilter}
      onChange={onChange}
      options={[
        { label: allUsersLabel, value: "all" },
        {
          value: "new",
          // A subtle green status dot flags that there are new users to
          // triage — quieter than a filled count badge, and it matches
          // the row highlight colour.
          label:
            newMembersCount > 0 ? (
              <Badge color="#22c55e" text={newUsersLabel} />
            ) : (
              newUsersLabel
            )
        }
      ]}
    />
  </div>
);

export default TeamFilterTabs;
